import { memo } from 'react';
import classNames from 'classnames';
import { Col, Row } from 'shards-react';
import iconSplit from '../assets/images/icon_synop_split.png';
import iconSign from '../assets/images/icon_synop_sign.png';

const PageTitle = ({ title, subtitle, className, serviceType, ...attrs }) => {
	const isSign = serviceType?.includes('signature');

	const classes = classNames('page-header', 'pb-3', className);
	const imgClasses = classNames('m-auto', 'transparent-img', 'icon-page-title')


	return (
		<Row noGutters className={classes}>
			<Col {...attrs} className='d-flex justify-content-between align-items-center pr-2'>
				<div>
					<span className='text-uppercase page-subtitle'>{title}</span>
					{subtitle && <h3 className='page-title'>{subtitle}</h3>}
				</div>
				{serviceType && <div className={isSign ? 'icon-page-title-container--down' : 'icon-page-title-container'}>
					<img id='main-logo' className={imgClasses} src={isSign ? iconSign : iconSplit} alt={`SYNOP ${serviceType && isSign ? 'Sign' : 'Split'}`} />
				</div>}
			</Col>
		</Row>
	);
};

export default memo(PageTitle);
